import request from "@/service";

/* 获取用户详情 */
export function pageStatisticsByParam(params) {
  console.log("pppp:", params);
  if (params.trainType !== undefined) {
    let length = params.trainType.length;
    params.trainType = params.trainType[length - 1];
  }

  return request({
    url: `/study/class/enroll/pageStatisticsByParam`,
    method: "get",
    params
  });
}

/* 导出培训信息 */
export function exportTrainInfo(params) {
  if (params.trainType !== undefined) {
    let length = params.trainType.length;
    params.trainType = params.trainType[length - 1];
  }
  return request({
    url: `/study/class/enroll/exportExcel`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}
